interface URLComponents {
    pathName: string;
    queryString: string;
    hashString: string;
}

export function extractURLComponents(url: string): URLComponents | undefined {
    if (!url) {
        return undefined;
    }

    // Extract params out of the route
    let pathName = url;
    let queryString = '';
    let hashString = '';

    const hashIndex = pathName.indexOf('#');
    if (hashIndex !== -1) {
        hashString = pathName.substring(hashIndex);
        pathName = pathName.substring(0, hashIndex);
    }

    const queryIndex = url.indexOf('?');
    if (queryIndex !== -1) {
        queryString = pathName.substring(queryIndex);
        pathName = pathName.substring(0, queryIndex);
    }

    if (pathName !== '/' && pathName.startsWith('/')) {
        // Routes don't include a leading forward slash, but the path from express does,
        // we must remove it to properly match the path to the routes array.
        pathName = pathName.substring(1);
    }

    return {
        pathName,
        queryString,
        hashString,
    };
}

export function buildUrl(baseUrl: string, params?: Record<string, any>) {
    let url = baseUrl;

    let hasFirstParam = url.includes('?');

    if (params) {
        Object.entries(params).forEach(([key, value]) => {
            if (hasFirstParam) {
                url += `&`;
            } else {
                hasFirstParam = true;
                url += `?`;
            }

            url += `${key}=${encodeURIComponent(String(value))}`;
        });
    }

    return url;
}
